<template>
  <div class="simulator">
    <el-form label-position="top" ref="userForm" :rules="rules" :inline="true" :model="deployGroup"
             label-width="auto">
      <el-form-item v-if="type.name" label="名称" prop="name">
        <el-input v-model="deployGroup.name" :disabled="store.state.sourceData['prohibit']"></el-input>
      </el-form-item>
      <el-form-item >
        <template #label>
          <div style="display: flex;align-items: center;">
            <label for="">Loop</label>
            <el-tooltip
                class="box-item"
                effect="dark"
                placement="top"
            >
              <img style="width: 16px;height: 16px;margin-left:5px"
                   src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/questionMark_icon.svg" alt="">
              <template #content>
                <div class="max-tooltip">
                  <span
                      style="color: #ffffff;margin-right: 8px">如果设置为 true，则会循环发送消息内容中定义的多条 json 数据</span>
                </div>
              </template>
            </el-tooltip>
          </div>
        </template>
        <el-radio v-model="deployGroup.loop" :label="true" border>True</el-radio>
        <el-radio v-model="deployGroup.loop" :label="false" border>False</el-radio>
      </el-form-item>
      <el-form-item prop="interval">
        <template #label>
          <div style="display: flex;align-items: center;">
            <label for="">时间间隔（ms）</label>
            <el-tooltip
                class="box-item"
                effect="dark"
                placement="top"
            >
              <img style="width: 16px;height: 16px;margin-left:5px"
                   src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/questionMark_icon.svg" alt="">
              <template #content>
                <div class="max-tooltip">
                  <span
                      style="color: #ffffff;margin-right: 8px">发出消息的间隔，单位为 ms</span>
                </div>
              </template>
            </el-tooltip>
          </div>
        </template>
        <el-input-number v-model="deployGroup.interval"/>
      </el-form-item>
      <el-form-item prop="data">
        <template #label>
          <div style="display: flex;align-items: center;">
            <label for="">消息内容</label>
            <el-tooltip
                class="box-item"
                effect="dark"
                placement="top"
            >
              <img style="width: 16px;height: 16px;margin-left:5px"
                   src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/questionMark_icon.svg" alt="">
              <template #content>
                <div class="max-tooltip">
                  <span style="color: #ffffff;margin-right: 8px">自定义 json 格式消息内容，支持定义多条 json 消息。如单条 json 数据 [{"a": 1}]，多条 json 数据 [{"a": 1}, {"b": 1}]</span>
                </div>
              </template>
            </el-tooltip>
          </div>
        </template>
        <el-input
            style="width: 500px"
            :rows="3"
            type="textarea"
            v-model="deployGroup.data"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {defineExpose, defineProps, onMounted, reactive, ref} from "vue";
import {useStore} from "vuex";
const userForm = ref(null);
const type = defineProps({
  componentType: {
    type: Object,
    default: () => {
      return {}
    }
  },
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }, name: {
    type: Boolean,
    default: () => {
      return true
    }
  }
})
const store = useStore();
let deployGroup = ref({
  name: '',
  loop: false,
  interval: 0,
  data: null
})
const rules = reactive({
  name: [{required: true, message: '请填写名称', trigger: 'blur'}],
  data: [{required: true, trigger: 'blur', message: ''}],
  interval: [{required: true, trigger: 'blur', message: ''}],
})
const getFormData = async () => {
  const isValid = await userForm.value.validate();
  if (isValid) {
    return deployGroup.value
  }
}
defineExpose({getFormData});
onMounted(() => {
  deployGroup.value = {...deployGroup.value, ...type.data}
  if (deployGroup.value.data) {
    deployGroup.value.data = JSON.stringify(deployGroup.value.data)
  }
})
</script>


<style scoped lang="less">
.max-tooltip {
  max-width: 280px !important;
}

.simulator {
  @import "public";
}
</style>